<div class="holder">
  <div class="filter">
    <h1>Invest with <span>us</span></h1>
    <div class="line"></div>
    <p>page still under construction</p>
  </div>
</div>
